import React, { useState } from "react";
import {
  Slider,
  FormControl,
  Typography,
  FormHelperText,
  Grid,
} from "@mui/material";
import PropTypes from "prop-types";
// import Grid from "@mui/material/Unstable_Grid2";

TwoLabelSlider.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
};

export default function TwoLabelSlider(props) {
  const {
    item,
    value,
    error = null,
    onChange,
    showErrorText = false,
    variant = "filled",
    size = "small",
    disabled = false,
  } = props;
  const [localValue, setLocalValue] = useState(value);

  const handleSliderChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlur = () => {
    let newValue = localValue;
    if (newValue !== "undefined") {
      if (newValue < item.min) newValue = item.min;
      if (newValue > item.max) newValue = item.max;
    } else newValue = item.default;
    setLocalValue(newValue);
    onChange({ target: { name: item.name, value: newValue } });
  };

  let helperText = "";
  if (showErrorText) helperText = error;

  return (
    <FormControl
      {...(error && { error: true })}
      variant={variant}
      sx={{ width: "100%" }}
      size={size}
    >
      <Typography variant="caption">{item.label}</Typography>
      <Grid container="true" spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
          }}
        >
          <Slider
            disabled={disabled}
            value={localValue}
            min={item.min}
            max={item.max}
            step={item.step}
            onChange={handleSliderChange}
            onChangeCommitted={handleBlur}
            aria-labelledby="input-slider"
          />
        </Grid>
        <Grid
          sx={{ paddingTop: "0px" }}
          size={{
            xs: 6,
          }}
        >
          <Typography variant="caption">
            {item.label1 + ": " + localValue + item.unit}
          </Typography>
        </Grid>
        <Grid
          size={{
            xs: 6,
          }}
          sx={{ paddingTop: "0px", textAlign: "right" }}
        >
          <Typography variant="caption">
            {item.label2 + ": " + (item.max - localValue) + item.unit}
          </Typography>
        </Grid>
      </Grid>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
